import * as yup from 'yup';
import { SimpleCallout } from '@web/components';
import { nullableImageFromCMSSchema, linkSchema } from '../schemas';

export const component = SimpleCallout;

export const schema = yup
  .object({
    image: nullableImageFromCMSSchema,
    body: yup.string().required(),
    level: yup.string(),
    link: linkSchema.required(),
    bgColor: yup.string(),
    bodyFontColor: yup.string(),
    bodyTypography: yup.string(),
    description: yup.string(),
    descFontColor: yup.string(),
    descTypography: yup.string(),
    ctaVariant: yup.string(),
  })
  .transform(value => ({
    image: value.image,
    body: value.body,
    level: value.level,
    link: value.link[0],
    bgColor: value.background_color || undefined,
    bodyFontColor: value.body_font_color || undefined,
    bodyTypography: value.body_typography || undefined,
    description: value.description,
    descFontColor: value.description_font_color || undefined,
    descTypography: value.description_typography || undefined,
    ctaVariant: value.ctaVariant,
  }));
